module.exports = __webpack_public_path__ + "img/i-filter-mono.d2221eee.svg";